<template>
   <div class="page">
     <page-header ></page-header>
     
     game
     <page-footer v-if="$route.meta.hasFooter"></page-footer>
   </div>
</template>
<script>
import Vue from 'vue'

export default {
  components: {
    pageFooter: () => import('@/components/footer'),
    pageHeader: () => import('@/components/layout/page-header')
  },
  data () {
    return {
     
    }
  },
  created () {
  },
  mounted () {
  },
  
  methods: {
    
  }
}
</script>
<style lang="less" scoped>



</style>
